import { getDisplayedAvatar, HOUSEHOLD_MEMBER_AVATARS } from '../caremap/CareMapFactory';
import type { CareMapState } from '../caremap/CareMapState';

export class DefaultAvatarProvider {
    // An illustration for someone who does not have one yet: the first that nobody else on the care
    // map is drawn with. forMemberId names a household member already on the care map, so they are
    // not counted against themselves.
    getDefaultAvatar = ({ careMap, preferredAvatar, forMemberId }: {
        careMap: Pick<CareMapState, 'getActiveCaremap'>;
        preferredAvatar?: string;
        forMemberId?: string;
    }): string => {
        const state = careMap.getActiveCaremap();

        const others = state
            ? [state.patient, ...state.household.members.filter(member => member.id !== forMemberId)]
            : [];
        const avatarsInUse = others.map(person => getDisplayedAvatar(person));

        if (preferredAvatar && !avatarsInUse.includes(preferredAvatar)) {
            return preferredAvatar;
        }

        const unusedAvatars = HOUSEHOLD_MEMBER_AVATARS.filter(a => !avatarsInUse.includes(a));

        return unusedAvatars[0] || HOUSEHOLD_MEMBER_AVATARS[0];
    };
}
